import type { MRT_ColumnDef } from "mantine-react-table-open";
import { HeaderWithHelpIcon } from "../../../../../mantine/mrt/components/header/HeaderWithHelpIcon";
import type { InlineEditTableColumnData } from "../../../../../types/inlineEditTable.types";
import type { PPAInvoiceNumberRange } from "../../PPAInvoiceNumberRangesPage.types";
import { isFormatValid } from "../utils/isFormatValid";

export const HELP_TEXT = `
Rechnungsnummernkreise werden je Unternehmen vergeben.

Die Rechnungsnummern können aus in beliebiger Kombination aus einem festen Text, wie bspw “R”, “Rechnung”, etc. und folgenden Variablen bestehen:

• %m Monat (aufgefüllt mit Nullen, also z. B. 01, 02 etc.) der Rechnungserstellung

• %b Monat (als Kurzform mit drei Buchstaben, z. B. Jan, Feb, …, Dez) der Rechnungserstellung

• %d Tag im Monat (aufgefüllt mit Nullen, also z. B. 01, 02 etc.) der Rechnungserstellung

• %y Jahr ohne Jahrtausend/Jahrhundert (also z. B. 21, 22) der Rechnungserstellung

• %Y Jahr inkl. Jahrtausend/Jahrhundert (also 2021, 2022) der Rechnungserstellung

• %l Fortlaufende Rechnungsnummer (beginnend mit “Zählerstartwert” – siehe nachfolgend). Es handelt sich hierbei um ein kleines L.

• %03l Fortlaufende Zählernummer mit vordefinierter Anzahl an Ziffern – Beispiel “001”

Derzeit werden die fortlaufenden Nummern jedes Jahr (Rechnungsstellung ab 01. Januar) auf 1 zurückgesetzt.
`;

export function getFormatColumn({
  validationErrors,
  setValidationErrors,
  t
}: InlineEditTableColumnData): MRT_ColumnDef<PPAInvoiceNumberRange> {
  return {
    id: "format",
    accessorFn: (row) => (row.format ? row.format : ""),
    header: "Format",
    Header: <HeaderWithHelpIcon headerText="Format" helpText={HELP_TEXT} />,
    enableSorting: false,
    size: 300,
    mantineEditTextInputProps: () => ({
      "aria-label": "Format",
      type: "text",
      error: validationErrors.format,
      placeholder: "Bsp.: R%Y-%05l",
      required: true,
      onChange: (event) => {
        const value = event.target.value;

        if (!isFormatValid(value)) {
          setValidationErrors({
            ...validationErrors,
            format: t("errors.PPA.InvoiceNumberRanges.formatError")
          });
        } else {
          delete validationErrors.format;
          setValidationErrors({ ...validationErrors });
        }
      }
    })
  };
}
